import { operateMaxShowLength } from '@/store/dict/config'

// 导出状态 options
const taskStatusOptions = [
  { label: '导入中', value: 1 },
  { label: '处理中', value: 2 },
  { label: '成功', value: 3 },
  { label: '失败', value: 4 },
  { label: '部分失败', value: 5 },
]

const config = function (fileName = '逾期明细表') {
  return {
    columns: [
      {
        name: 'gmtCreate',
        columnProps: {
          label: '导出时间',
          prop: 'gmtCreate',
          width: '220px',
        },
      },
      {
        name: 'userName',
        columnProps: {
          label: '操作人名称',
          prop: 'userName',
        },
      },
      {
        name: 'userAccount',
        columnProps: {
          label: '操作人账号',
          prop: 'userAccount',
        },
      },
      {
        name: 'taskStatus',
        columnProps: {
          label: '导出状态',
          prop: 'taskStatus',
          width: '80px',
        },
        render: ({ row }) => {
          const findItem = taskStatusOptions.find((item) => item.value === row.taskStatus)
          return this.$createElement('span', {}, (findItem && findItem.label) || '--')
        },
      },
      {
        name: 'operate',
        columnProps: {
          label: '导出详情',
        },
        maxShowLength: operateMaxShowLength,
        getOperateList: ({ row }) => {
          if (row.taskStatus === 1 || row.taskStatus === 2 || row.taskStatus === 4) {
            return []
          }
          return [
            { name: 'export', label: fileName, action: () => this.exportHandle(row) },
          ]
        },
        type: 'operate',
      },
    ],
  }
}

export default config
